import { useState } from "react";
import api, { apiError } from "../../lib/api";
import { toast } from "sonner";

export const AccountEmailSelect = ({ account, mailboxes, onChanged, testId }) => {
  const [busy, setBusy] = useState(false);
  const change = async (mailbox_id) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/email-verify/accounts/${account.id}/mailbox`, { mailbox_id: mailbox_id || null });
      toast.success(mailbox_id ? "Verification email linked — auto verification works for this account" : "Email unlinked — this account uses screenshot upload");
      onChanged && onChanged(data);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <select value={account.ev_mailbox_id || ""} disabled={busy} onChange={(e) => change(e.target.value)} data-testid={testId}
      className="w-full rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-sm text-slate-800 disabled:opacity-60">
      <option value="">No email — screenshot upload</option>
      {mailboxes.map((m) => <option key={m.id} value={m.id}>{m.email}{m.status !== "connected" ? " (reconnect needed)" : ""}</option>)}
    </select>
  );
};
